import tinycolor from "tinycolor2";
import { setCookie } from "../../../Template/_Fragment/ColorWheelOverlay/ColorWheelOverlay";
import { setColor } from "../../../Template/_Fragment/ColorWheelOverlay/ColorWheelOverlay";

if (document.querySelector('.member--colorButton')) {
    document.querySelectorAll('.member--colorButton').forEach(button => {
        button.addEventListener('click', () => {
            const hexColor = button.getAttribute('data-color')
            const hsvaColor = tinycolor(hexColor).toHsvString()
            const tinyColor = tinycolor.fromRatio(hsvaColor);

            const figure = button.closest('figure')
            figure.classList.add('member--colorActive')
            setTimeout(() => {
                figure.classList.remove('member--colorActive');
            }, 500);

            setTimeout(() => {
                setColor(tinyColor)
                setCookie('colorAccent', tinyColor, 30);
            }, 250);
        })

        button.addEventListener('focus', () => {
            button.closest('.overlay').style.opacity = "1"
        })
        button.addEventListener('blur', () => {
            button.closest('.overlay').style.opacity = ""
        })
    })
}